import styled from "styled-components";
import { md, sm } from "../../../AppTheme.styled";

const StyledMenuHead = styled.img`
  width: 111px;

  ${sm} {
    width: 118px;
  }
  ${md} {
    width: 130px;
  }
`;

export default StyledMenuHead;
